<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData>0" />
                <div
                    v-else
                    class="mb-4"
                >
                    <div class="text-base mb-7 py-4 md:py-5">
                        <DataInfo
                            :effectDate="showData.effectDate"
                            :isShowPayDate="flagData.isShowPayDate"
                            :payDate="showData.payDate"
                            :isShowPayWay="flagData.isShowPayWay"
                            :payWayText="showData.payWayText"
                            :isShowPayPeriod="flagData.isShowPayPeriod"
                            :payPeriod="showData.payPeriod"
                            :isShowEnsurePeriod="flagData.isShowEnsurePeriod"
                            :ensurePeriod="showData.ensurePeriod"
                        />
                        <div class="px-0 pt-5">
                            <div class="bg-green-100 border-dashed border rounded md:rounded-md border-secondary divide-y divide-dashed px-3 py-3.5 xs:px-4 grid">
                                <div
                                    v-if="flagData.isShowPayDate"
                                    class="grid table-space"
                                >
                                    <div class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]">
                                        <div>年金給付開始日</div>
                                        <div>
                                            <DatePicker
                                                v-model:visiblePopup="flagData.visiblePopup"
                                                v-model:userDate="inputData.payDate"
                                                :isYearROC="false"
                                                :visible-popup="flagData.visiblePopup"
                                                :maxDate="showData.maxPayDate"
                                                :minDate="showData.minPayDate"
                                            />
                                            <button
                                                class="input-base input-calendar"
                                                @click="flagData.visiblePopup=true"
                                                v-text="inputData.payDateText"
                                            />
                                        </div>
                                        <div class="grid col-start-2 md:col-start-3">
                                            <p class="error-msg md:px-2">
                                                {{ showData.datePeriodText }}
                                            </p>
                                        </div>
                                        <div class="grid col-start-2 md:col-start-2">
                                            <p class="xs:w-[12.5rem] error-msg -mb-1 min-h-[0.25rem]">
                                                {{ showData.errorMsg }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="flagData.isShowPayWay"
                                    class="grid table-space"
                                >
                                    <div class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]">
                                        <div class="pr-5">
                                            年金給付方式
                                        </div>
                                        <div class="md:flex md:justify-between md:col-span-2">
                                            <Radio
                                                v-for="(item,index) in showData.payWayList"
                                                :key="index"
                                                v-model:checkedValue="inputData.payWay"
                                                :value="item.code"
                                                :text="item.text"
                                                class="mb-2.5 items-baseline px-1"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="flagData.isShowPayPeriod"
                                    class="grid table-space"
                                >
                                    <div class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]">
                                        <div class="pr-5">
                                            年金給付期間
                                        </div>
                                        <div class="md:flex md:justify-between md:col-span-2 grid grid-cols-2">
                                            <Radio
                                                v-for="(item,index) in showData.payPeriodList"
                                                :key="index"
                                                v-model:checkedValue="inputData.payPeriod"
                                                :value="item.code"
                                                :text="item.text"
                                                class="mb-2.5 items-baseline px-1"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="flagData.isShowEnsurePeriod"
                                    class="grid table-space"
                                >
                                    <div class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]">
                                        <div class="pr-5">
                                            年金保證期間
                                        </div>
                                        <div class="md:flex md:justify-between md:col-span-2 grid grid-cols-2">
                                            <Radio
                                                v-for="(item,index) in showData.ensurePeriodList"
                                                :key="index"
                                                v-model:checkedValue="inputData.ensurePeriod"
                                                :value="item.code"
                                                :text="item.text"
                                                class="mb-2.5 items-baseline px-1"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="border-style">
                                    <ol class="list-decimal text-base text-gray-700 ml-6 space-y-2">
                                        <li
                                            v-for="(item,index) in showData.noteList"
                                            :key="index"
                                        >
                                            {{ item }}
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="isGettingData > 0 || !hasChangeData"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import DatePicker from '@/components/dialogs/DatePicker.vue';
import Skeletons from '@/components/skeletons/Skeletons.vue';
import DataInfo from './DataInfo.vue';
import dialogContnet from '@/json/dialogContent';
import { inject, toRefs, reactive, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { formatToTwDate } from '@/utils/is/dateUtils';
import { validPayDate, setData, modalShow, submitData } from './service';

export default {
    components: {
        Bottombar,
        Loading,
        ButtonNextService,
        Skeletons,
        DatePicker,
        Radio,
        DataInfo,
    },
    setup() {
        const $vfm = inject('$vfm');
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const result = computed(() => store.state.services.changeItemsResult[code]);

        const showData = {
            payWayList: [],
            payPeriodList: [],
            ensurePeriodList: [],
            minPayDate: null,
            maxPayDate: null,
            /** 年金開始給付日 */
            payDate: null,
            /** 契約始期 */
            effectDate: null,
            /** 年金給付方式 */
            payWay: '',
            /** 年金給付方式 */
            payWayText: '',
            /** 年金給付期間 */
            payPeriod: '0',
            /** 年金保證期間 */
            ensurePeriod: '0',
            errorMsg: '',
            noteList: [],
            datePeriodText: computed(() => {
                if (data.showData.minPayDate == null || data.showData.maxPayDate == null) {
                    return '';
                }
                return `(需介於${formatToTwDate(data.showData.minPayDate)}~${formatToTwDate(data.showData.maxPayDate)})`;
            }),

        };

        const inputData = {
            /** 年金開始給付日 */
            payDate: '',
            /** 年金給付方式 */
            payWay: '',
            /** 年金給付期間 */
            payPeriod: '0',
            /** 年金保證期間 */
            ensurePeriod: '0',
            payDateText: computed(() => {
                return formatToTwDate(data.inputData.payDate);
            }),
        };

        const data = reactive({
            isLoading: false,
            isGettingData: 0,
            isSubmitOk: false,
            flagData: {
                isShowPayDate: true,
                isShowPayWay: true,
                isShowPayPeriod: true,
                isShowEnsurePeriod: true,
                visiblePopup: false,
            },
            showData: showData,
            inputData: inputData,
        });

        setData(data, result);

        const saveAndgoNext = () => {
            showData.errorMsg = validPayDate(data.flagData.isShowPayDate, data.inputData.payDate, data.showData.maxPayDate, data.showData.minPayDate);
            if (showData.errorMsg) {
                modalShow($vfm, dialogContnet.validateMsg);
                return;
            }

            submitData(data, store, code);
        };

        const hasChangeData = computed(() => {
            if ((data.inputData.payDate.replaceAll('/', '-') === data.showData.payDate) && (data.inputData.payWay === data.showData.payWay) && (data.inputData.payPeriod === data.showData.payPeriod) && (data.inputData.ensurePeriod === data.showData.ensurePeriod)) {
                return false;
            }
            return true;
        });

        watch(() => data.inputData.payDate, (nV, oV) => {
            data.showData.errorMsg = validPayDate(data.flagData.isShowPayDate, data.inputData.payDate, data.showData.maxPayDate, data.showData.minPayDate);
        });

        return {
            ...toRefs(data),
            saveAndgoNext,
            hasChangeData,
        };
    },
};
</script>
<style scoped lang="scss">
.max-width {
    @apply w-full sm:max-w-[30rem] md:max-w-[24rem];
}
.table-space {
    @apply py-2.5 first:pt-0 last:pb-0;
}
</style>
